module.exports = __webpack_public_path__ + "static/media/logo.c8239a75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 883
// module chunks = 0